import * as React from 'react';
import { cn } from '@/core/lib/utils';
import { HealthLogTypeIcon } from './HealthLogTypeIcon';

type HealthLogType = 
  | 'symptom'
  | 'medication'
  | 'appointment'
  | 'vital'
  | 'mood'
  | 'temperature'
  | 'bloodwork'
  | 'sleep'
  | 'nutrition'
  | 'seizure'
  | 'incident'
  | 'note';

interface HealthLogTypeSelectorProps {
  value?: HealthLogType;
  onChange?: (type: HealthLogType) => void;
  disabled?: boolean;
  className?: string;
}

const logTypes: { value: HealthLogType; label: string }[] = [
  { value: 'symptom', label: 'Symptom' },
  { value: 'medication', label: 'Medication' },
  { value: 'appointment', label: 'Appointment' },
  { value: 'vital', label: 'Vital Signs' },
  { value: 'mood', label: 'Mood' },
  { value: 'temperature', label: 'Temperature' },
  { value: 'bloodwork', label: 'Bloodwork' },
  { value: 'sleep', label: 'Sleep' },
  { value: 'nutrition', label: 'Nutrition' },
  { value: 'seizure', label: 'Seizure' },
  { value: 'incident', label: 'Incident' },
  { value: 'note', label: 'Note' },
];

export function HealthLogTypeSelector({
  value,
  onChange,
  disabled = false,
  className,
}: HealthLogTypeSelectorProps) {
  return (
    <div className={cn('grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2', className)}>
      {logTypes.map((type) => (
        <button
          key={type.value}
          type="button"
          onClick={() => onChange?.(type.value)}
          disabled={disabled}
          className={cn(
            'flex flex-col items-center gap-2 p-3 rounded-lg border-2 transition-all',
            'hover:border-sage-300 hover:bg-sage-50',
            value === type.value
              ? 'border-sage-500 bg-sage-50'
              : 'border-gray-200 bg-white',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
        >
          <HealthLogTypeIcon type={type.value} size="md" />
          <span className="text-xs font-medium text-gray-700">{type.label}</span>
        </button>
      ))}
    </div>
  );
}

export default HealthLogTypeSelector;
